<template>
    <div
        class="o-p-list"
        :style="componentStyles"
    >
        <div class="o-p-list__subtitle">
            {{$t(componentParams.subtitle)}}
        </div>
        <div class="o-p-list__title">
            {{$t(componentParams.title)}}
        </div>
        <div
            :class="`o-p-list__list ${isEmptyTitle ? 'o-p-list__list--empty-header' : ''}`"
            ref="posterList"
            :style="{...listStyle, ...aPListItemParams.style, ...aPListHeaderParams.style}"
        >
            <template
                v-for="(category, index) in preparedListItems"
            >
                <APListHeader
                    :key="category.id + index"
                    :first="index === 0"
                    :title="category.name"
                    :params="aPListHeaderParams.params"
                />

                <APListItem
                    v-for="(item, i) in category.listItems"
                    :key="item.id + index"
                    :title="item.meta[`name_${locale}`] || item.meta.name"
                    :dark="i === 0 || i % 2 === 0"
                    :floor="getSecondColunmData(item)"
                    :nr="getThirdColunmData(item)"
                    ref="listItem"
                    :floor-color="floorColor[item.denormaliseData.floor.level]"
                    :configFloorColor="getSecondColunmColor(item)"
                    :is-capitalise="isCapitaliseListItemTitle"
                    :style="calculatedStyles"
                />
            </template>
            <template
                v-if="!componentParams.is_hide_service"
            >
                <APListHeader
                    :title="$t('componentParams.service', 'Service')"
                    :params="aPListHeaderParams.params"
                >
                    <template v-if="isShowServiseFloorInfo"><span/></template>
                </APListHeader>
                <template
                    v-if="isShowServiceCategory"
                >
                    <APListItem
                        v-for="service in getServiceData"
                        :key="service.id"
                        :title="service.meta[`name_${locale}`] || service.meta.name"
                        dark
                        class="a-p-list-item--service"
                        :isCapitalise="isCapitaliseListItemTitle"
                        ref="listItem"
                    >
                        <template>
                            <img class="a-p-list-item__service-icon" :src="service.files.icon" alt="service icon">
                        </template>
                    </APListItem>
                </template>
                <template
                    v-else
                >
                    <APListItem
                        v-for="(item, i) in getServiceData"
                        :key="item.id + 'service' + i"
                        :title="item.meta[`name_${locale}`] || item.meta.name"
                        :dark="i === 0 || i % 2 === 0"
                        :floor="getSecondColunmData(item)"
                        :nr="getThirdColunmData(item)"
                        ref="listItem"
                        :floor-color="floorColor[item.denormaliseData.floor.level] || 'var(--a-p-list-item__floor-background, #E66640)'"
                        :configFloorColor="getSecondColunmColor(item)"
                        :isCapitalise="isCapitaliseListItemTitle"
                    />
                </template>
                <OPQrWidget
                    ref="oPQrWidget"
                    v-if="isShowQrWidgeAfterService"
                />
            </template>
            <template
                v-if="componentParams.is_show_elevators"
            >
                <APListHeader
                    :title="elevatorTitle"
                    :params="aPListHeaderParams.params"
                    class="a-p-list-header--elevator"
                >
                    <template>
                        <span class="a-p-list-header__subtitle">
                            {{elevatorSubtitle}}
                        </span>
                    </template>
                </APListHeader>
                <APListItem
                    v-for="(elevator, i) in elevators"
                    :key="elevator.name + i"
                    :title="t(elevator, 'name') || elevator.meta[`name_${locale}`] || elevator.meta.name"
                    :dark="i === 0 || i % 2 === 0"
                    class="a-p-list-item--elevator"
                    :nr="getElevatorShortName(elevator)"
                    ref="listItem"
                />
                <OPQrWidget
                    v-if="isShowQrWidgeAfterService"
                />
            </template>
        </div>
        <div
            v-if="componentParams.is_hide_service"
            :class="`o-p-list__list o-p-list__list--right ${isEmptyTitle ? 'o-p-list__list--empty-header' : ''}`"
            :style="{...aPListItemParams.style, ...aPListHeaderParams.style}"
        >
            <OPQrWidget 
                v-if="!isShowWidgetLast"
            />
            <APListHeader
                :title="$t('componentParams.service', 'Service')"
                :params="aPListHeaderParams.params"
            >
                <template><span/></template>
            </APListHeader>
            <APListItem
                v-for="service in getServiceData"
                :key="service.id"
                :title="service.meta[`name_${locale}`] || service.meta.name"
                dark
                class="a-p-list-item--service"
                :isCapitalise="isCapitaliseListItemTitle"
            >
                <template>
                    <img class="a-p-list-item__service-icon" :src="service.files.icon" alt="service icon">
                </template>
            </APListItem>
            <OPQrWidget 
                v-if="isShowWidgetLast"
            />
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {COLUMN_COUNT} from './constants'

import OPQrWidget from '../o-p-qr-widget/o-p-qr-widget'
import APListItem from '../../atoms/a-p-list-item/a-p-list-item'
import APListHeader from '../../atoms/a-p-list-header/a-p-list-header'

import {reportWarning} from "@/utils/helpers/health-monitoring";

export default {
    name: 'OPList',
    components: {
        OPQrWidget,
        APListItem,
        APListHeader
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            aPListItemParams: {},
            aPListHeaderParams: {},
            checkSizeTimeout: null,
            adjustListHeightTimeout: null,
            listItemHeight: null,
            columnCount: null
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale
        }),
        ...mapGetters([
            't',
            't2',
            'getUnit',
            'getElevators',
            'getTerminalId',
            'getCategories',
            'getCategoryById',
            'getMapConfigProp',
            'getBuildingByIndex',
            'getObjectFloorIndex',
            'getServiceCategories',
            'getObjectsByCategoryAZ',
            'getDenormalisedTerminal',
            'getServiceCategoriesRoot',
            'getDenormalisedObjectById',
            'getDenormalisedObjectsById'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPList.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPList.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPList.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPList.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        categories() {
            return this.componentParams.categories || []
        },
        exclusionCategories() {
            return this.componentParams.exclusion_categories || []
        },
        preparedListItems() {
            let categories = _.cloneDeep(this.categories)
            if(this.componentParams.ignore_service_category) {
                categories = categories.filter(({id}) => this.getServiceCategoriesRoot.id !== id)
            }
            categories = categories
                .map((category, i, arr) => {
                    const newCategory = category

                    newCategory.listItems = []

                    this.getCategories.forEach(({id, parent_id: parentId}) => {
                        if(newCategory.id == parentId || id == newCategory.id) {
                            this.getObjectsByCategoryAZ(id).forEach(obj => {
                                if(!newCategory.listItems.some(item => item.id === obj.id)) {
                                    newCategory.listItems.push({
                                        ...obj,
                                        denormaliseData: this.getDenormalisedObjectsById(obj.id)[0]
                                    })
                                }
                            })
                        }
                    });

                    if(this.isFlitredItems) newCategory.listItems = newCategory.listItems.filter(item => {
                        return this.activeLevels.includes(item.denormaliseData.floor.level)
                            && this.activeBuildIds.some(buildingIndex => buildingIndex == item.denormaliseData.floor.building_index)
                            && !this.exclusionCategories.some(id => item.denormaliseData.lists.categories.includes(id))
                            && this.objectPriorityFilter(item, category, arr.filter(cat => cat.id !== newCategory.id))
                            && this.checkObjectsInPrevCategories(item.id, arr.filter(cat => cat.id !== newCategory.id))
                    })

                    return newCategory
                })
                .filter(category => !this.exclusionCategories.some(id => id == category.id))

            return categories
        },
        getFiltredServiceCategories() {
            // TO DO - add more logic and and this getter
            const categories = [];

            this.getServiceCategories.forEach(category => {
                let services = this.getObjectsByCategoryAZ(category.id)
                services = services.map(({id}) => getDenormalisedObjectsById(id))
            });
            return categories
            // return this.getServiceCategories.filter(item => {
            //     return this.activeLevels.includes(item.denormaliseData.floor.level)
            //         && this.activeBuildIds.includes(item.denormaliseData.floor.building_index)
            //         && !this.exclusionCategories.some(id => item.denormaliseData.lists.categories.includes(id))
            // })
        },
        getServiceObjects() {
            return this.getServiceCategories.reduce((acc, category) => {
                let services = this.getObjectsByCategoryAZ(category.id)
                services = services.map(obj => ({
                    ...obj,
                    denormaliseData: this.getDenormalisedObjectById(obj.id)
                }))
                return [...acc, ...services]
            }, []);
        },
        listStyle() {
            return {
                columnCount: this.columnCount,
            }
        },
        floorColor() {
            return this.getMapConfigProp(`map_views.poster.floor_color`, {})
        },
        activeLevels() {
            return this.getMapConfigProp('map_views.poster.active_levels', []);
        },
        activeBuildIds() {
            return this.getMapConfigProp('map_views.poster.active_building_ids', [])
        },
        isEmptyTitle() {
            return !this.$t(this.componentParams?.title) && !this.$t(this.componentParams?.subtitle)
        },
        levelsNumbersToLevelNameMaping() {
            return this.getMapConfigProp('map_views.poster.levels_numbers_to_level_name_maping', {})
        },
        buildingsInfo() {
            return this.getMapConfigProp('map_views.poster.buildings_info', {})
        },
        exclusionServiseCategories() {
            return this.componentParams.exclusion_service_categories || []
        },
        preparedServiceCategories() {
            return this.getServiceCategories.filter(({id}) => !this.exclusionServiseCategories.some(serviceId => serviceId == id))
        },
        isShowWidgetLast() {
            return this.componentParams.is_show_widget_last
        },
        isShowQrWidgeAfterService() {
            return this.componentParams.is_show_qr_widget_after_service
        },
        getServiceData() {
            const serviceMethod = this.componentParams.service_data_method_name ? this.componentParams.service_data_method_name : 'preparedServiceCategories'
        
            return this[serviceMethod]
        },
        isFlitredItems() {
            if(this.componentParams.hasOwnProperty('is_filtred_items')) {
                return this.componentParams.is_filtred_items
            }
            return true
        },
        elevatorTitle() {
            const titleTranslateName = this.componentParams.elevator_title || 'ui.elavators'
            return this.$t(titleTranslateName, 'Elevators')
        },
        elevatorSubtitle() {
            const subtitleTranslateName = this.componentParams.elevator_subtitle || 'ui.shortening'
            return this.$t(subtitleTranslateName, 'Förkortning')
        },
        elevators() {
            const dataProvider = this.componentParams.elevator_data_provider || 'elevatorsFromConfig';

            return this[dataProvider]
        },
        elevatorsFromConfig() {
            return this.componentParams.elevators || this.getElevators
        },
        isCapitaliseListItemTitle() {
            if(this.componentParams.hasOwnProperty('is_capitalize_list_item_title')) {
                return this.componentParams.is_capitalize_list_item_title
            }
            return true
        },
        isShowServiseFloorInfo() {
            if(this.componentParams.hasOwnProperty('is_show_service_floor_info')) {
                return this.componentParams.is_show_service_floor_info
            }
            return true
        },
        isShowServiceCategory() {
            if(this.componentParams.hasOwnProperty('is_show_service_category')) {
                return this.componentParams.is_show_service_category
            }
            return true
        },
        isFiltredListByUnique() {
            if(this.componentParams.hasOwnProperty('is_filtred_list_by_unique')) {
                return this.componentParams.is_filtred_list_by_unique
            }
            return true
        },
        objectsWithIndexes() {
            return this.objects
        },
        minListItemHeight() {
            const minListItemHeight = this.componentParams.min_list_item_height
            if(minListItemHeight) {
                return this.extractNumber(`${minListItemHeight}`).itemHeight
            }

            return false
        },
        maxListItemHeight() {
            const maxListItemHeight = this.componentParams.max_list_item_height
            if(maxListItemHeight) {
                return this.extractNumber(`${maxListItemHeight}`).itemHeight
            }

            return false
        },
        isActivateAdjustListItemHeight() {
            return this.componentParams.is_activate_adjust_list_item_height
        },
        isActivateChangeColumnsCount() {
            return this.componentParams.is_activate_change_columns_count
        },
        isUseQrLikeLastListElement() {
            return this.componentParams.is_use_qr_like_last_list_element
        },
        initialListItemHeightParmasName() {
            return this.componentParams.initial_list_item_height_params_name || '--a-p-list-item__floor-line-height'
        },
        listItemHeightStyles() {
            return this.componentParams.list_item_height_styles || ['--a-p-list-item__floor-line-height', '--a-p-list-item__line-height']
        },
        calculatedStyles() {
            const paramsObj = {}
            this.listItemHeightStyles.forEach(params => {
                paramsObj[params] = this.listItemHeight
            })

            return paramsObj
        }
    },
    methods: {
        getComponentsParams(componentName) {
            return {
                style: {
                    ...this.getMapConfigProp(`components.${componentName}.styles`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.styles`)
                },
                params: {
                    ...this.getMapConfigProp(`components.${componentName}.params`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.params`)
                }
            }
        },
        getSecondColunmData(item) {
            const method = this.aPListItemParams?.params?.get_second_column_data_method || 'getListItemFloorLevel';
            return this[method](item)
        },
        getSecondColunmColor(item) {
            const method = this.aPListItemParams?.params?.get_second_column_color_method || 'getListItemFloorColor';

            return this[method](item)
        },
        getListItemFloorColor() {
            return this.aPListItemParams?.params?.floor_color || ''
        },
        getListItemFloorColorFromLevelNumber(item) {
            return this.aPListItemParams?.params?.levels_floor_color[item.denormaliseData.floor.level] || ''
        },
        getListItemFloorLevel(item) {
            return this.levelsNumbersToLevelNameMaping[item.denormaliseData.floor.level] || item.denormaliseData.floor.level
        },
        getListItemFloorShortName(item) {
            return this.t2(item.denormaliseData.floor, 'short_name', this.getListItemFloorLevel(item))
        },
        getListItemBuildingNameFromMeta(item) {
            const itemMetaFloor = this.t2(item, 'floor');
            if(itemMetaFloor) return itemMetaFloor

            return this.getListItemBuildingName(item)
        },
        getListItemCategoryName(item) {
            const categoryId = this.aPListItemParams?.params?.category_id_for_column_data;

            if(!categoryId || !item.lists.categories.some(id => id == categoryId)) return this.getListItemBuildingNameFromMeta(item)
            const activeCategoryId = item.lists.categories.find(id => {
                const category = this.getCategoryById(id);
                return category.parent_id == categoryId;
            })

            return this.t2(this.getCategoryById(activeCategoryId), 'name', '-')
        },
        getListItemBuildingName(item) {
            const buildingIndex = item?.denormaliseData?.floor?.building_index
            if(buildingIndex) {
                const building = this.getBuildingByIndex(item?.denormaliseData?.floor?.building_index)
                
                return building ? this.t(building, 'short_name') : '-'
            } else {
                return '-'
            }
        },
        getListItemBuildingColor(item) {
            const buildingObject = this.getBuildingByIndex(item?.denormaliseData?.floor?.building_index);
            const buildingColor = buildingObject?.meta.background_color
            if(buildingColor) return buildingColor
            const buildingInfo = this.buildingsInfo[item?.denormaliseData?.floor?.building_index]
            return buildingInfo ? buildingInfo.color : 'var(--a-p-list-item__floor-background, #E66640)'
        },
        getThirdColunmData(item) {
            const method = this.aPListItemParams?.params?.get_third_column_color_method || 'getUnitAlias';

            return this[method](item)
        },
        getUnitAlias(item) {
            return this.getUnit(item.denormaliseData.unit.id).alias || '-'
        },
        getOtherFloorElevatorData(item) {
            if(this.activeLevels.includes(item?.denormaliseData?.floor?.level)) {
                return this.getUnitAlias(item)
            }

            const buildingIndex = item.denormaliseData?.floor?.building_index;
            return this.t(item, 'location_short', buildingIndex);
        },
        getItemlocationIcon(item) {
            const icon = this.t(item.files, 'location_icon')
            if(icon) {
                return `<img class="a-p-list-item__floor-icon" src="${icon}" alt="floor icon"/>`
            }

            const locationFallbackDataMenthod = this.aPListItemParams?.params?.location_fallback_data_menthod || 'getOtherFloorElevatorData';
            return this[locationFallbackDataMenthod](item)
        },
        getElevatorShortName(object) {
            const icon = this.t(object, 'location_icon')
            if(icon) {
                return `<img class="a-p-list-item__floor-icon" src="${icon}" alt="floor icon"/>`
            }
            if(object.id) {
                const elevator = this.getDenormalisedObjectsById(object.id)[0];
                const buildingIndex = elevator?.floor?.building_index;

                return this.t(elevator, 'location_short', buildingIndex);
            } else {
                return this.t(object, 'short_name', '')
            }
        },

        getUnitIndex(item) {
            return item?.index?.index || '-';
        },
        /**
        * To prevent duplicate objects in different categories 
        * we check prew categories and if store available in some category dont add object
        */
        checkObjectsInPrevCategories(id, arr) {
            if(!this.isFiltredListByUnique) return true
            const objects = arr.reduce((acc, item) => [...acc, ...(item?.listItems || [])], [])

            return !objects.some(obj => obj.id === id) 
        },
        objectPriorityFilter(item, category) {
            const itemPrio = item.lists.categories.reduce((prio, categoryId) => {
                const categoryPrioId = this.categories.find(category => category.id == categoryId)?.duplicate_objects_filter_priority

                if(categoryPrioId < prio) return categoryPrioId

                return prio
            }, 999)

            const categoryPrio = category?.duplicate_objects_filter_priority

            if(itemPrio == 999 || !categoryPrio) {
                return true
            }

            return itemPrio == categoryPrio
        },
        checkQRCovered() {
            if(this.componentParams.is_check_qr_covered) {
                const qrElem = this.$refs.oPQrWidget.$el;
                const qrElemRect = qrElem.getBoundingClientRect()
                const listItems = this.$refs.listItem
                const listItemEl = listItems[listItems.length - 1].$el
                const itemRect = listItemEl.getBoundingClientRect()

                return itemRect.bottom + 8 > qrElemRect.top
            } else {
                return false
            }
        },
        checkListSize() {
            const posterListWrapper = this.$refs.posterList
            if(posterListWrapper) {
                const listRects = posterListWrapper.getBoundingClientRect();
                const items = Array.from(posterListWrapper.querySelectorAll('div')).filter(el => el.getBoundingClientRect().x)
                const lastItem = items.pop()

                const lastItemRect = lastItem.getBoundingClientRect();

                if(listRects.bottom < lastItemRect.top || listRects.right < lastItemRect.left ) {
                    const notPlacedItems = items.filter(item => {
                        const itemRect = item.getBoundingClientRect()

                        return listRects.bottom < itemRect.top || listRects.right < itemRect.left
                    })
                        
                    const listItemsNotPlaced = notPlacedItems.filter(item => item.classList.contains('a-p-list-item'))

                    const msg = `; Poster name - ${this.t(this.getDenormalisedTerminal, 'name')}; Poster id - ${this.getTerminalId}; ${notPlacedItems.length} div's not fit, ${listItemsNotPlaced.length} objects not fit`;
                    reportWarning(msg);
                }
            }
        },
        getListItemElement() {
            let element;
            if(this.isUseQrLikeLastListElement) {
                const listItemEl = this.$refs.oPQrWidget
                element = listItemEl.$el
            } else {
                const listItemEl = this.$refs.listItem
                element = listItemEl[listItemEl.length - 1].$el
            }
            return element
        },
        makeListItemsSmaller() {
            const listEl = this.$refs.posterList
            const listItemEl = this.getListItemElement()

            if(!listItemEl) {
                this.adjustListHeightTimeout = setTimeout(() => {
                    this.makeListItemsSmaller()
                }, 300)
            } else {
                const listRect = listEl.getBoundingClientRect()
                const listElemRect = listItemEl.getBoundingClientRect()

                if(listRect.right < listElemRect.right || this.checkQRCovered()) {
                    this.reduceListItemHeight();

                    this.adjustListHeightTimeout = setTimeout(() => {
                        this.makeListItemsSmaller()
                    }, 300)
                } else {
                    this.checkListItemHeight()
                }
            }
        },
        makeListItemsBigger() {
            const listEl = this.$refs.posterList
            const listItemEl = this.getListItemElement()

            if(!listItemEl) {
                this.adjustListHeightTimeout = setTimeout(() => {
                    this.makeListItemsBigger()
                }, 300)
            } else {
                const listRect = listEl.getBoundingClientRect()
                const listElemRect = listItemEl.getBoundingClientRect()

                if(listRect.right > listElemRect.right) {
                    this.increaseListItemHeight();

                    this.adjustListHeightTimeout = setTimeout(() => {
                        this.makeListItemsBigger()
                    }, 300)
                } else {
                    this.makeListItemsSmaller();
                }
            }
        },
        manageListPlacement() {
            if(this.componentParams.is_activate_placed_feature) {
                this.makeListItemsBigger();
            } else {
                this.makeListItemsSmaller();
            }
        },
        reduceListItemHeight() {
            const lineHeightData = this.extractNumber(this.listItemHeight);
            if(!lineHeightData) return
            const itemHeight = lineHeightData.itemHeight;
            const newItemHeight = (itemHeight - itemHeight*0.02);

            if(this.isActivateChangeColumnsCount && this.minListItemHeight && newItemHeight < this.minListItemHeight) {
                this.changeColumnCount()
            } else {
                this.listItemHeight = newItemHeight + lineHeightData.size
            }
        },
        increaseListItemHeight() {
            const lineHeightData = this.extractNumber(this.listItemHeight);
            if(!lineHeightData) return
            const itemHeight = lineHeightData.itemHeight;
            const newItemHeight = (itemHeight + itemHeight*0.02);

            if(this.isActivateChangeColumnsCount && this.minListItemHeight && newItemHeight < this.minListItemHeight) {
                this.changeColumnCount()
            } else {
                this.listItemHeight = newItemHeight + lineHeightData.size
            }
        },
        extractNumber(str) {
            if(!str) return ''
            const match = str.match(/^(\d+(\.\d+)?)([a-zA-Z%]+)?$/);
            return match ? { itemHeight: parseFloat(match[1]), size: match[3] || '' } : null;
        },
        changeColumnCount() {
            this.listItemHeight = this.aPListItemParams.style[this.initialListItemHeightParmasName];
            ++this.columnCount;
        },
        checkListItemHeight() {
            const msg = `; Poster name - ${this.t(this.getDenormalisedTerminal, 'name')}; Poster id - ${this.getTerminalId};`;

            if(this.minListItemHeight && this.listItemHeight < this.minListItemHeight) {
                reportWarning(msg + 'List item height too small');
            }
            if(this.maxListItemHeight && this.listItemHeight > this.maxListItemHeight) {
                reportWarning(msg + 'List item height too big');
            }
        }
    },
    mounted() {
        this.aPListItemParams = this.getComponentsParams('APListItem');
        this.aPListHeaderParams = this.getComponentsParams('APListHeader');
        this.columnCount = +this.componentParams?.columnCount || COLUMN_COUNT;
        this.checkSizeTimeout = setTimeout(() => {
            this.checkListSize()
            if(this.isActivateAdjustListItemHeight) {
                this.manageListPlacement()
                this.listItemHeight = this.aPListItemParams.style[this.initialListItemHeightParmasName];
            }
        }, 5000)
    },
    beforeDestroy() {
        if(this.checkSizeTimeout) clearTimeout(this.checkSizeTimeout)
        if(this.adjustListHeightTimeout) clearTimeout(this.adjustListHeightTimeout)
    }
}
</script>

<style lang="scss">
@import "o-p-list";
</style>
